import globals from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    selectField: {
        marginBottom: 10,
        marginTop: 4
    }
});
